import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { InspectionLink, InspectionsLink } from 'utils/link';
import DeleteMutation from 'mutations/inspection_result/delete';
import Confirmation from 'components/form/confirmation';

const DeleteButton = ({ inspectionResult }) => {
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.inspection_result.deleted');
      const inspectionId = inspectionResult.inspection?.id;
      navigate(inspectionId ? InspectionLink(inspectionId) : InspectionsLink());
    },
    onError: () => {
      setError('error.inspection_result.delete');
    },
  });

  return (
    <Confirmation
      title={<FormattedMessage id="header.inspection_result.delete" />}
      description={<FormattedMessage id="confirmation.inspection_result.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: inspectionResult.id } });
      }}
    >
      <Button color="error" variant="outlined" disabled={deleteMutationData.loading}>
        <FormattedMessage id="button.delete" />
      </Button>
    </Confirmation>
  );
};

export default DeleteButton;
